import axios from 'axios';

import type {
  ClaimStageConfigurationCreateJson,
  ClaimStageConfigurationModel,
  ClaimStageConfigurationMoveJson,
  ClaimStageConfigurationUpdateJson,
} from '~/server_shared/openapi/data-contracts';

const getBaseUrl = (organizationId: number) => `/sysconfig/api/v1/organizations/${organizationId}/claim_stage`;

export const createClaimStageConfiguration = async (
  organizationId: number,
  values: ClaimStageConfigurationCreateJson
): Promise<ClaimStageConfigurationModel> => {
  const url = getBaseUrl(organizationId);
  const response = await axios.post<ClaimStageConfigurationModel>(url, values);
  return response.data;
};

export const updateClaimStageConfiguration = async (
  organizationId: number,
  stageKey: string,
  updates: ClaimStageConfigurationUpdateJson
): Promise<ClaimStageConfigurationModel> => {
  const url = `${getBaseUrl(organizationId)}/${stageKey}`;
  const response = await axios.patch<ClaimStageConfigurationModel>(url, updates);
  return response.data;
};

export const moveClaimStageConfiguration = async (
  organizationId: number,
  stageKey: string,
  fromIndex: number,
  toStageKey: string,
  toIndex: number
): Promise<void> => {
  const move: ClaimStageConfigurationMoveJson = {
    stage_key: stageKey,
    from_index: fromIndex,
    to_stage_key: toStageKey,
    to_index: toIndex,
  };
  await axios.post<void>(`${getBaseUrl(organizationId)}/move`, move);
};
